import { z } from "zod";

export const roleSchema = z.enum([
  "tenant_admin",
  "data_lead",
  "analyst",
  "field_coordinator",
  "auditor",
]);
export type Role = z.infer<typeof roleSchema>;

export const severitySchema = z.enum(["critical", "high", "medium", "low"]);
export type Severity = z.infer<typeof severitySchema>;

export const readMethodSchema = z.enum(["smart", "amr", "manual"]);
export type ReadMethod = z.infer<typeof readMethodSchema>;

/** Where a fact came from (docs/DATA_MODEL.md §2 and §3). */
export const sourceSchema = z.enum(["import", "field", "market", "user", "rule", "gate", "system"]);
export type Source = z.infer<typeof sourceSchema>;

export const partyRoleSchema = z.enum(["wholesaler", "retailer"]);

/** RFC 9457 problem detail, the shape of every error response. */
export const problemSchema = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number().int(),
  detail: z.string().optional(),
  instance: z.string().optional(),
  errors: z.array(z.record(z.unknown())).optional(),
});
export type Problem = z.infer<typeof problemSchema>;

export const uuidSchema = z.string().uuid();
export const isoDateTimeSchema = z.string().datetime({ offset: true });
